import _ from 'lodash';
import angular from 'angular';
import Logger from '../../../shared/logger';
import UtilsService from '../../../services/utilsService';

// eslint-disable-next-line import/prefer-default-export
export const RouteService = (Restangular, $localStorage, $cookies) => {
    let isLoaded = false;
    const init = function () {
        // eslint-disable-next-line no-undef
        try {
            return Promise.all([
                Restangular.all('system')
                    .all('preferences')
                    .get('')
                    .then((response) => {
                        $localStorage.sysprefs = response.result;
                    }),
                Restangular.all('system')
                    .all('crmDefaults')
                    .get('')
                    .then((response_1) => {
                        $localStorage.sysDefaults = response_1.result;
                    }),
                Restangular.all('metadata')
                    .all('gdprLocations')
                    .get('')
                    .then((response_2) => {
                        $localStorage.gdprLocations = response_2.result;
                    }),
                Restangular.all('metadata')
                    .all('translatedCountriesList')
                    .get('')
                    .then((response_3) => {
                        $localStorage.translatedCountriesList = response_3.result;
                    }),
            ]).then((res) => {
                isLoaded = true;
            });
        } catch (error) {
            return Logger.error(error);
        }
    };

    const getStaticData = function () {
        return Restangular.all('metadata')
            .one('staticLookups', 'en-US')
            .get('')
            .catch((error) => Logger.error(error));
    };

    const getUILanguage = function (language) {
        return Restangular.all('metadata')
            .one('uiLanguages', language)
            .get('')
            .catch((error) => Logger.error(error));
    };

    const getEmailTemplates = function (language, type) {
        return Restangular.all('metadata')
            .one('emailTemplates', language)
            .all(type)
            .get('')
            .catch((error) => Logger.error(error));
    };

    const getSystemPreference = function (key) {
        const sysprefs = $localStorage.sysprefs || {};
        return angular.copy(sysprefs[key]);
    };

    const getSystemDefaults = function (key) {
        const config = $localStorage.sysDefaults || {};
        return angular.copy(config[key]);
    };

    const getSystemPreferenceAsync = async function (key) {
        await waitTillLoaded();
        return getSystemPreference(key);
    };

    const getSystemDefaultsAsync = async function (key) {
        await waitTillLoaded();
        return getSystemDefaults(key);
    };

    const getUser = function (email) {
        return Restangular.all('user')
            .get('')
            .catch((error) => Logger.error(error));
    };

    const getIsAuthUserBlocked = function (data) {
        return Restangular.all('user')
            .all('isBlocked')
            .post(data)
            .catch((error) => Logger.error(error));
    };
    const unBlockUser = function (data) {
        return Restangular.all('user')
            .all('unBlockUser')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const getUserPreference = function (key) {
        UtilsService.cookiesOverride($cookies);
        const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
        if (userPrefs) {
            return _.get(userPrefs, key);
        }
        return null;
    };

    const getUserData = function (key) {
        UtilsService.cookiesOverride($cookies);
        const userData = UtilsService.parseJSON($cookies.get('userData'));
        if (userData) {
            return _.get(userData, key);
        }
        return null;
    };

    const getRefreshMetaData = function () {
        return Restangular.all('metadata')
            .all('refresh')
            .get('')
            .catch((error) => Logger.error(error));
    };

    const getIdToken = async () => {
        try {
            const token = await Restangular.all('token')
                .get('');

            if (!token) {
                // for server side pdf render
                return this.getCookie('x-access-token');
            }

            return token;
        } catch (err) {
            Logger.error(err);
        }
        return null;
    };

    const login = function ({ token, expiresInSec, employerId }) {
        Restangular.setDefaultHttpFields({
            withCredentials: true,
        });

        return Restangular.all('login')
            .post({
                token,
                expiresIn: expiresInSec,
                employerId,
            })
            .catch((error) => Logger.error(error));
    };

    const logout = function () {
        return Restangular.all('logout')
            .get('')
            .catch((error) => Logger.error(error));
    };

    const addUserData = function (data) {
        return Restangular.all('user')
            .customPUT(data)
            .catch((error) => Logger.error(error));
    };

    const isUserExists = function ({ userId }) {
        return Restangular.all('user')
            .all('exists')
            .post({ userId })
            .then(({ result }) => result)
            .catch((error) => Logger.error(error));
    };

    const isUserActive = function ({ userId }) {
        return Restangular.all('user')
            .all('isActive')
            .post({ userId })
            .then(({ result }) => result)
            .catch((error) => Logger.error(error));
    };

    const getUserAuthType = function ({ userId }) {
        return Restangular.all('user')
            .all('authType')
            .post({ userId })
            .then(({ result }) => result)
            .catch((error) => Logger.error(error));
    };

    const addUserToAuth0 = function (data) {
        return Restangular.all('user')
            .all('create')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const blockActiveSessions = function () {
        return Restangular.all('user')
            .all('blockMemorySessions')
            .post()
            .catch((error) => Logger.error(error));
    };

    const postRequestDemo = function (data) {
        return Restangular.all('email')
            .all('demo')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const sendMail = function (data) {
        return Restangular.all('email')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const sendPositionApprovalEmails = function (positionId, emailData) {
        return Restangular
            .one('position', positionId)
            .all('sendApprovalEmails')
            .post(emailData)
            .catch((error) => Logger.error(error));
    };

    const getPositionApprovalLinks = function (positionId, emailData) {
        return Restangular
            .one('position', positionId)
            .all('approvalLink')
            .post(emailData)
            .catch((error) => Logger.error(error));
    };

    const sendContactCandidateMail = function (data) {
        return Restangular.all('email')
            .all('contactCandidate')
            .post(data)
            .catch((error) => Logger.error(error));
    };
    const sendEmployerRepMail = function (data) {
        return Restangular.all('employerRep')
            .all('sendMail')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const getPublicEmailDomains = () => Restangular.all('email')
        .all('publicDomains')
        .get('')
        .catch((error) => Logger.error(error));

    const clearAllCaches = () => Restangular.all('cache')
        .all('clearAll')
        .post({})
        .catch((error) => Logger.error(error));

    const confirmResponse = (positionId, params) => Restangular
        .one('position', positionId)
        .all('confirmResponse')
        .post(params)
        .catch((error) => Logger.error(error));

    const sendPasswordResetRequestNotification = function (data) {
        return Restangular.all('email')
            .all('requestPasswordReset')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const sendEmployerAtsSettingUpdatesNotification = function (data) {
        return Restangular.all('email')
            .all('employerAtsSettingUpdated')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const isActiveCampaignsExist = function (employerId) {
        return Restangular
            .one('employer', employerId)
            .all('isActiveCampaignsExist')
            .get('')
            .catch((error) => Logger.error(error));
    };

    const isActiveAutoContactCampaignsExist = function (employerId) {
        return Restangular
            .one('employer', employerId)
            .all('isActiveAutoContactCampaignsExist')
            .get('')
            .catch((error) => Logger.error(error));
    };

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const pollUntilTaskFinished = async (taskId, pollIntervalMs = 500) => {
        const taskData = await getTaskData(taskId);
        if (taskData?.status === 'processing') {
            await delay(pollIntervalMs);
            return pollUntilTaskFinished(taskId);
        }

        if (taskData?.status === 'complete') {
            return taskData?.results;
        }

        if (taskData?.status === 'error') {
            throw new Error('Failed to complete task');
        }

        return null;
    };

    const getTaskData = function (taskId) {
        return Restangular
            .all('system')
            .one('task', taskId)
            .get('')
            .then((response) => response?.result)
            .catch((error) => Logger.error(error));
    };

    const refreshTalentCache = function () {
        return Restangular.all('talent')
            .all('refreshTalentCache')
            .post({})
            .catch((error) => Logger.error(error));
    };

    const getThemeSettings = (key) => {
        const defaultThemeSettings = {
            tftMainLogoUrl: '/assets/img/logo.svg?fixme',
            tftPrimaryColor: '#4632E2',
        };
        let useNewColorScheme = -1;
        if ($localStorage?.employerData) {
            useNewColorScheme = 0;
            const colorScheme = $localStorage?.employerData?.settings?.colorScheme;
            if (colorScheme) {
                useNewColorScheme = 1;
            } else {
                if ($localStorage?.resellerData) {
                    const colorScheme = $localStorage?.resellerData?.settings?.colorScheme;
                    if (colorScheme) {
                        useNewColorScheme = 1;
                    }
                }
            }
        }
        const themeSettings = _.merge({}, defaultThemeSettings, useNewColorScheme ? $localStorage?.sysDefaults?.colorSchemeSettings : {});
        return key ? themeSettings[key] : themeSettings;
    };

    const waitTillLoaded = async () => {
        const maxRetries = 30;
        for (let i = 0; i < maxRetries && !isLoaded; i++) {
            await delay(100);
        }
    };

    const getThemeSettingsAsync = async (key) => {
        await waitTillLoaded();
        return getThemeSettings(key);
    };

    const blockUserSessions = function (data) {
        return Restangular.all('user')
            .all('blockSessions')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    init();

    return {
        clearAllCaches,
        getStaticData,
        getUILanguage,
        getEmailTemplates,
        getSystemPreference,
        isUserExists,
        getUserAuthType,
        getUser,
        getUserPreference,
        getUserData,
        getRefreshMetaData,
        logout,
        addUserData,
        addUserToAuth0,
        postRequestDemo,
        getSystemDefaults,
        sendMail,
        sendEmployerRepMail,
        sendContactCandidateMail,
        blockActiveSessions,
        init,
        getPublicEmailDomains,
        sendPositionApprovalEmails,
        getPositionApprovalLinks,
        confirmResponse,
        isUserActive,
        sendPasswordResetRequestNotification,
        sendEmployerAtsSettingUpdatesNotification,
        isActiveCampaignsExist,
        getIsAuthUserBlocked,
        unBlockUser,
        isActiveAutoContactCampaignsExist,
        pollUntilTaskFinished,
        refreshTalentCache,
        getThemeSettings,
        getSystemDefaultsAsync,
        getThemeSettingsAsync,
        getSystemPreferenceAsync,
        login,
        getIdToken,
        blockUserSessions,
        delay,
    };
};

angular
    .module('TALENYA-FE')
    .factory('RouteService', RouteService);
